import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {environment} from '@env/environment';
import {interval, Subscription} from 'rxjs';
import {concatMap, filter} from 'rxjs/operators';
import {AuthenticationService} from '@app/core/service/authentication.service';

@Component({
    selector: 'ngc-maintenance',
    templateUrl: './maintenance.component.html',
    styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent implements OnInit, OnDestroy {

    isTestingActive = false;
    subscriptions: Subscription[] = [];
    readonly TESTING_QUERY_PARAM = 'testingaftermaintenance';
    readonly TRUE = 'true';
    readonly IS_SCHEDULED_MAINTENANCE = environment.maintenance;
    readonly SCHEDULED_MAINTENANCE_TITLE = 'Website is not available due to scheduled maintenance.';
    readonly SCHEDULED_MAINTENANCE_MESSAGE = 'We apologize for the inconveniences caused. Our team is about to release the new version. We will get back on-line soon.';
    readonly SERVICE_UNAVAILABLE_TITLE = 'Website is down for maintenance.';
    readonly SERVICE_UNAVAILABLE_MESSAGE = 'We apologize for the inconveniences caused. We will get back on-line soon.';

    constructor(private activatedRoute: ActivatedRoute,
                private authenticationService: AuthenticationService,
                private router: Router
    ) {}

    ngOnInit() {
        this.isTestingActive = this.restoreTestingParamToLocalStorage() === this.TRUE;

        if (!this.isTestingActive) {
            this.subscriptions.push(
                this.activatedRoute.params.subscribe((params: Params) => {
                    if (params['testingaftermaintenance'] === this.TESTING_QUERY_PARAM) {
                        this.saveTestingParamToLocalStorage();
                        this.router.navigate(['']);
                    }
                })
            );

            this.subscriptions.push(
                interval(3000)
                    .pipe(
                        concatMap(() => this.authenticationService.checkServerStatus()),
                        filter((status: boolean) => status)
                    )
                    .subscribe(() => {
                        const returnUrl = this.router.routerState.snapshot.root.queryParams['returnUrl'];
                        this.authenticationService.redirectToLoginPage({queryParams: {returnUrl: returnUrl}});
                    })

            );
        }
    }

    private restoreTestingParamToLocalStorage(): string {
        return window.localStorage.getItem(this.TESTING_QUERY_PARAM);
    }

    private saveTestingParamToLocalStorage(): void {
        window.localStorage.setItem(this.TESTING_QUERY_PARAM, this.TRUE);
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
}
